import React, { FunctionComponent } from 'react';
import Card from '../../../Card/Card';
import Button from '../../../../design-system/Button/Button';
import { H5 } from '../../../../design-system/Headings/Headings';

const SHOWCASE_URL =
    'https://www.apimatic.io/product/context-plugins/showcase?utm_campaign=context_plugins&utm_source=portal_editor#examples';

const ExternalLinkIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ContextPluginShowcaseCard: FunctionComponent = () => (
    <Card className="flex items-center justify-between">
        <div>
            <H5 className="mb-1">See Context Plugins in Action</H5>
            <p className="text-14 text-goose-800">
                Explore our Context Plugins showcase to see live API Examples.
            </p>
        </div>
        <Button
            text="View live examples"
            fill="secondary"
            icon={<ExternalLinkIcon />}
            className="shrink-0 ml-4"
            onClick={() => window.open(SHOWCASE_URL, '_blank', 'noopener,noreferrer')}
        />
    </Card>
);
